/*********************** Custom JS for Boost AI Search & Discovery  ************************/

setTimeout(() => {
  const config = window.boostSDAppConfig;
  
  const productPrice = document.querySelectorAll(
    ".boost-sd__format-currency > span"
  );

  if (productPrice.length > 0) {
    productPrice.forEach((price) => {
      price.innerText = `${price.innerText} ${config.generalSettings.current_currency}`
    });
  }
}, 3000);